import { CustomPricingSort } from "@classes-service-types/custom-pricing-sort.ts";
import { SortOrder } from "@classes-service-types/sort-order.ts";
import type { BulkUpdateSeverity } from "./types";

/** Distinct from the table's group so the modal's toasts don't land in its stack. */
export const BULK_UPDATE_TOAST_GROUP = "br-bulk";

/** A success message is read and dismissed; a failure needs long enough to read the detail. */
export const TOAST_LIFE_SUCCESS_MS = 5_000;
export const TOAST_LIFE_FAILURE_MS = 15_000;

export const BULK_UPDATE_BANNER_STYLES: Record<BulkUpdateSeverity, { classes: string; icon: string }> = {
  success: { classes: "border-teal-50 bg-teal-light text-teal-900", icon: "check_circle" },
  warn: { classes: "border-yellow-900/40 bg-yellow-100/20 text-gray-700", icon: "warning" },
  error: { classes: "border-red-300 bg-red-light text-red-700", icon: "error" },
};

export const ROWS_PER_PAGE_OPTIONS = [25, 50, 100, 200];

/** The largest page, so a full bulk update can be built without paging. */
export const DEFAULT_ROWS_PER_PAGE = 200;

/** Mirrors `MAX_BULK_UPDATE_ROWS` in classes-service; the bulk action disables above it. */
// spec: docs/specs/DATSC-1361-custom-pricing-bulk-update.spec.md §2 (selection scope and the cap)
export const MAX_BULK_UPDATE_ROWS = 200;

export const ROWS_PER_PAGE_DROPDOWN_OPTIONS = ROWS_PER_PAGE_OPTIONS.map((v) => ({
  key: `${v}`,
  value: v,
}));

export const SORT_OPTIONS = [
  { name: "Created At", key: CustomPricingSort.CreatedAt },
  { name: "Title", key: CustomPricingSort.Title },
  { name: "Session Name", key: CustomPricingSort.SessionName },
  { name: "Updated At", key: CustomPricingSort.UpdatedAt },
] as const;

export const SORT_ORDER_OPTIONS = [
  { name: "Descending", key: SortOrder.Desc },
  { name: "Ascending", key: SortOrder.Asc },
] as const;

export const COLUMN_OPTIONS = [
  { key: "id", name: "ID" },
  { key: "home_institution_name", name: "Institution" },
  { key: "home_institution_id", name: "Institution ID" },
  { key: "session_name", name: "Session Name" },
  { key: "session_id", name: "Session ID" },
  { key: "title", name: "Scholarship Title" },
  { key: "class_fees_price", name: "Classes Price" },
  { key: "internships_price", name: "Internship Price" },
  { key: "base_price", name: "Total Price" },
  { key: "base_internships_price", name: "Original Internship Price" },
  { key: "base_class_fees_price", name: "Original Class Price" },
  { key: "base_housing_price", name: "Original Housing Price" },
  { key: "base_insurance_price", name: "Original Insurance Price" },
  { key: "base_group_flight_price", name: "Original Group Flight Price" },
  { key: "base_public_transportation_price", name: "Original Public Transportation Price" },
  { key: "base_events_price", name: "Original Events Price" },
  { key: "base_total_academic_fees_price", name: "Original Total Academic Fees Price" },
  { key: "academic_year", name: "Session Academic Year" },
  { key: "status", name: "Session Status" },
  { key: "channel", name: "Session Channel" },
  { key: "owner", name: "Session Owner" },
  { key: "city", name: "Session City" },
  { key: "marketplace", name: "Session Marketplace" },
  { key: "created_at", name: "Created At" },
  { key: "updated_at", name: "Updated At" },
  { key: "updated_by", name: "Updated By" },
];

export const COLUMNS_NOT_TO_SHOW_AT_LOAD = [
  "id",
  "home_institution_id",
  "session_id",
  "academic_year",
  "status",
  "channel",
  "owner",
  "city",
  "marketplace",
  "created_at",
  "updated_at",
  "updated_by",
  "base_housing_price",
  "base_insurance_price",
  "base_group_flight_price",
  "base_public_transportation_price",
  "base_events_price",
  "base_total_academic_fees_price",
  "base_class_fees_price",
  "base_internships_price",
  "base_price",
];
